import '../../Components/NewCartOrder/NewCartOrder.scss';
import '../../Components/NewCartOrder/NewCartOrderMobile.scss';
import { Component } from 'react';
import * as session from 'modules/session';
import UserGifts from 'frontend/Components/UserGifts/UserGifts';
import { analytics } from 'frontend/analytics/analytics';
import { getFbPixelDataToPurchase } from 'frontend/analytics/analyticsHelper';
import MinAmountMessage from 'frontend/Components/cart/min-amount-message/MinAmountMessage';
import {
  isOnlyForDelivery,
  isOnlyForSelf,
} from 'frontend/Components/NewCartOrder/Helpers';
import Emitter from 'frontend/Components/NewCartOrder/Emitters';
import Empty from 'frontend/Components/NewCartOrder/Components/Empty/Empty';
import BlockProducts from 'frontend/Components/NewCartOrder/Components/CartProductsBlock/CartProductsBlock';
import { Breadcrumbs } from '@shared/ui/breadcrumbs';
import { FreeDeliveryWarning } from '@entities/delivery';
import { PlaceOrder } from '@widgets/place-order';
import { PageContainer, BlockContainer } from '@shared/ui/content-containers';
import { Subtitle } from '@shared/ui/titles';
import { RoutesWithSubRoutes, useRouteLoaderData } from '@shared/lib/routing';
import { useTranslation } from 'react-i18next';
import { Helmet } from 'react-helmet-async';
import PromoPhoneForm from './ui/PromoPhoneForm';
import styles from './cart.module.scss';

class Cart extends Component {
  constructor(props) {
    super(props);

    this.state = {
      isPickupProducts: isOnlyForSelf(),
      isDeliveryProducts: isOnlyForDelivery(),
      isNotEmptyUserGifts: true,
      sessionUserGifts: session.get('userGifts', []),
    };
  }

  componentDidMount() {
    Emitter.addListener('CART_CHANGE', this.cartChange);
    Emitter.addListener('USER_GIFTS_CHANGE', this.onUserGiftsChange);
    analytics.fbPixel(
      'InitiateCheckout',
      getFbPixelDataToPurchase({
        countryCurrency: this.props.country.currency,
        cart: session.get('cart'),
      }),
    );
  }

  componentDidUpdate(prevProps, prevState) {
    if (prevState.sessionUserGifts !== this.state.sessionUserGifts) {
      this.setState({
        isPickupProducts: isOnlyForSelf(),
        isDeliveryProducts: isOnlyForDelivery(),
      });
    }
  }

  componentWillUnmount() {
    Emitter.removeListener('CART_CHANGE', this.cartChange);
    Emitter.removeListener('USER_GIFTS_CHANGE', this.onUserGiftsChange);
  }

  onUserGiftsChange = () => {
    this.setState({ sessionUserGifts: session.get('userGifts', []) });
  };

  cartChange = () => {
    this.setState({
      isPickupProducts: isOnlyForSelf(),
      isDeliveryProducts: isOnlyForDelivery(),
      sessionUserGifts: session.get('userGifts', []),
    });
  };

  setIsNotEmptyUserGifts = (isNotEmptyUserGifts) => {
    this.setState({ isNotEmptyUserGifts });
  };

  render() {
    const { isPickupProducts, isDeliveryProducts, isNotEmptyUserGifts } =
      this.state;
    const { match: { isExact } = {}, t, routes, city } = this.props;

    const { items = [], total } = session.get('cart') || {};
    const {
      free_order_cost,
      delivery: { order_min },
    } = city.info;
    const isItems = !!items.length;
    const title = t('NewCart.cart');
    return (
      <>
        <Helmet title={t('NewCart.cart')} />
        <PageContainer>
          <Breadcrumbs
            links={[
              {
                text: title,
              },
            ]}
          />
          <div className={styles.cart}>
            {isItems ? (
              <>
                <MinAmountMessage total={total} orderMin={order_min} />
                {isExact && <PromoPhoneForm />}
                <BlockProducts />
                <RoutesWithSubRoutes routes={routes} />
                {isExact && (
                  <>
                    <FreeDeliveryWarning
                      total={total}
                      orderMin={order_min}
                      freeOrderCost={free_order_cost}
                    />
                    <PlaceOrder
                      isPickupProducts={isPickupProducts}
                      isDeliveryProducts={isDeliveryProducts}
                    />
                  </>
                )}
              </>
            ) : (
              <>
                <Empty />
                {isNotEmptyUserGifts && (
                  <BlockContainer>
                    <Subtitle>{t('BlockProducts.user_gift')}</Subtitle>
                    <p className="classToParagraph">
                      {t('BlockProducts.userGiftDescription')}
                    </p>
                    <UserGifts
                      isExact={isExact}
                      setIsNotEmptyUserGifts={this.setIsNotEmptyUserGifts}
                    />
                  </BlockContainer>
                )}
              </>
            )}
          </div>
        </PageContainer>
      </>
    );
  }
}
function EnrichedCart(props) {
  const cityLayoutData = useRouteLoaderData('city-layout');
  const { t } = useTranslation();
  return <Cart t={t} {...props} {...cityLayoutData} />;
}

export default EnrichedCart;
